import Textarea from 'shared/components/Textarea';

import styled from 'shared/utils/styled';

export const CheckboxLabel = styled('span')(({ theme }) => ({
  fontSize: 14,
  fontWeight: 600,
  color: theme.palette.primary.main,
}));

export const StyledTextarea = styled(Textarea)(() => ({
  minHeight: 120,
}));
